import React from "react";
import { offer } from "../data/salesCopy";
import { Countdown } from "./Countdown";
import { PricingCards } from "./PricingCards";
import { SectionHeader } from "./SectionHeader";
export function OfferSection() {
  return <section id="ofertas" data-hide-sticky className="scroll-mt-2 bg-chalk-soft py-9 md:py-16" data-id="element-143" data-mp="8mn6ykdgow1x">
      <div className="mx-auto max-w-5xl px-5" data-id="element-144" data-mp="dex16clm0ia0">
        <div className="mx-auto max-w-xl rounded-2xl bg-chalk-dark p-4 text-center text-white md:rounded-3xl md:p-7" data-id="element-145" data-mp="id8dqv3ah6vx">
          <div className="flex items-center justify-between gap-3 md:justify-center" data-id="element-146" data-mp="meaczbx7hixw">
            <span className="flex items-center gap-2 text-xs font-bold md:text-sm" data-id="element-147" data-mp="re662g4d7pyo">
              <span className="h-2 w-2 animate-pulse rounded-full bg-coral" aria-hidden="true" data-id="element-148" data-mp="rc3kq9e5ql0a" />
              {offer.live}
            </span>
            <span className="rounded-md bg-coral px-2 py-0.5 text-[10px] font-bold md:text-xs" data-id="element-149" data-mp="2t6b6kfzxjvl0">{offer.priceUp}</span>
          </div>
          <p className="mt-3 text-xs font-bold tracking-wide text-pencil md:mt-4 md:text-sm" data-id="element-150" data-mp="2y4mhku1yoc4t">
            {offer.endsIn} <span className="font-normal text-white/70" data-id="element-151" data-mp="12pldcy6drlbx">· {offer.noReturn}</span>
          </p>
          <div className="mt-3 md:mt-5" data-id="element-152" data-mp="xvh05x6iuh2e">
            <Countdown tone="dark" data-id="element-153" data-mp="sx76xs4cxqjf" />
          </div>
          <div className="mt-4 md:mt-6" data-id="element-154" data-mp="sxyqu5oldztv">
            <div className="flex justify-between text-[11px] font-semibold md:text-xs" data-id="element-155" data-mp="owdgos3fzznd">
              <span data-id="element-156" data-mp="1lme86yv74u8d">{offer.spotsLabel}</span>
              <span className="text-pencil" data-id="element-157" data-mp="1ll338vq0lgfo">{offer.spotsTaken}% TOMADOS</span>
            </div>
            <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={offer.spotsTaken} aria-valuemin={0} aria-valuemax={100} data-id="element-158" data-mp="1gol0g1e8vs5z">
              <div className="h-full rounded-full bg-pencil" style={{
              width: `${offer.spotsTaken}%`
            }} data-id="element-159" data-mp="17n4qfurcds2a" />
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-14" data-id="element-160" data-mp="17ucannik70k">
          <SectionHeader title={offer.title} subtitle={offer.subtitle} center data-id="element-161" data-mp="3sd3x80wnhv3b" />
        </div>
        <div className="mt-5 md:mt-10" data-id="element-162" data-mp="3tu98d4tab7gp">
          <PricingCards data-id="element-163" data-mp="3tvauc4bu9ed7" />
        </div>
      </div>
    </section>;
}